
export default {
  name: 'SectionsTestimonialSlider',
  props: {
    sectionTestimonialSlider: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      tabIndex: 0,
    }
  },
  computed: {
    videoTestimonials() {
      const items = this.sectionTestimonialSlider?.video_testimonials
      if (!items || !items.length) return []
      return items
    },
  },
  methods: {
    tab(index) {
      this.tabIndex = index
    },
  },
}
